import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f33191"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "光储充能量管理系统", -1))
const _hoisted_3 = { class: "timer" }
const _hoisted_4 = { class: "top-container" }
const _hoisted_5 = { class: "top-left-container" }
const _hoisted_6 = { class: "nav photovoltaic" }
const _hoisted_7 = { class: "nav energy-storage" }
const _hoisted_8 = {
  class: "nav canvas",
  style: {"width":"60%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "canvas-title" }, "能量概览", -1))
const _hoisted_10 = { class: "canvas-container" }
const _hoisted_11 = { class: "top-right-container" }
const _hoisted_12 = { class: "nav photovoltaic-monitor" }
const _hoisted_13 = { class: "nav energy-storage-monitor" }
const _hoisted_14 = { class: "bottom-container" }
const _hoisted_15 = { class: "nav analyze" }
const _hoisted_16 = { class: "nav low-carbon" }

import { Timer } from '@element-plus/icons-vue'
import Photovoltaic from './components/Photovoltaic.vue'
import { onBeforeUnmount, onMounted, reactive, ref } from 'vue'
import EnergyFlowCanvas from '@/components/EnergyFlowCanvas.vue'
import EnergyStorage from './components/EnergyStorage.vue'
import EnergyStorageMonitor from './components/EnergyStorageMonitor.vue'
import PhotovoltaicMonitor from './components/PhotovoltaicMonitors.vue'
import LowCarbon from './components/LowCarbon.vue'
import Analyze from './components/Analyzes.vue'
import { useStationData } from './useStationData'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const {
  stationInfoData,
  essEnergyConversionStats,
  essStationFlowData,
  fetchEssStationStatus,
  startIntervalStationData,
  startIntervalFlowData,
} = useStationData(route.query.stationId as string)

const stationContainer = ref()
const visualViewportHandler = () => {
  const scale = window?.visualViewport?.scale || 1
  document.documentElement.style.setProperty('--browser-scale', scale.toString())
}

const timer = ref(new Date())
let canvasTimer: number | null
let intervalId: number | undefined

const updateTimer = () => {
  timer.value = new Date()
}

const formatDate = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}
onMounted(() => {
  // initStationOverviewData()
  intervalId = window.setInterval(updateTimer, 1000)
  window.visualViewport?.addEventListener('resize', visualViewportHandler)
  visualViewportHandler()
  startIntervalFlowData()
  startIntervalStationData()
})

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
  window.visualViewport?.removeEventListener('resize', visualViewportHandler)
})

/**
 * 动态设置 html 的 font-size，基于设计稿宽度（如1920px）
 */
const setHtmlFontSize = () => {
  const designWidth = 1920
  const html = document.documentElement
  const clientWidth = html.clientWidth
  // 100px = 1rem，等比缩放
  html.style.fontSize = (clientWidth / designWidth) * 100 + 'px'
}

onMounted(() => {
  setHtmlFontSize()
  window.addEventListener('resize', setHtmlFontSize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setHtmlFontSize)
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "stationContainer",
    ref: stationContainer,
    class: "station-container"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, { style: {"margin":"0 10px"} }, {
          default: _withCtx(() => [
            _createVNode(_unref(Timer), { color: "#a8d7ff" })
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(formatDate(timer.value)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Photovoltaic, { info: _unref(stationInfoData) }, null, 8, ["info"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(EnergyStorage, { info: _unref(stationInfoData) }, null, 8, ["info"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(EnergyFlowCanvas, {
            info: _unref(essStationFlowData),
            textColor: '#a8d7ff'
          }, null, 8, ["info"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(PhotovoltaicMonitor, {
            stationId: (_unref(route).query.stationId as string)
          }, null, 8, ["stationId"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(EnergyStorageMonitor, {
            stationId: (_unref(route).query.stationId as string)
          }, null, 8, ["stationId"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(Analyze, {
          stationId: (_unref(route).query.stationId as string)
        }, null, 8, ["stationId"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(LowCarbon, { data: _unref(essEnergyConversionStats) }, null, 8, ["data"])
      ])
    ])
  ], 512))
}
}

})